import * as React from 'react'

import './styles.scss'
import { configurations } from '../../api'
import { ButtonTag } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import WebWidgetCreator from './WebWidgetCreator'
import DNS_URLS from '../../constants/dnsUrls'
import WebWidgetDisplay from './WebWidgetDisplay'
import ModalDelete from 'components/ModalDelete'
import { toastMessage } from 'utils/messages'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const WebWidgetEdit = (props) => {
  const { channels, createWebWidget, widgets: widgetsExternal, getAllWebWidgetExternal, onDataWidgetToQR } = props
  const [widgets, setWidgets] = React.useState(widgetsExternal)
  const [widgetIdToEdit, setWidgetIdToEdit] = React.useState(null)
  const [dataToEdit, setDataToEdit] = React.useState(null)
  const [widgetIdToRemove, setWidgetIdToRemove] = React.useState(null)
  const [isOpenModalWebWidgetDisplay, setIsOpenModalWebWidgetDisplay] = React.useState(false)
  const [dataToPreview, setDataToPreview] = React.useState(null)
  const [valueButtonCopy, setValueButtonCopy] = React.useState({})
  const [isOpenRemoveModal, setIsOpenRemoveModal] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [isSubmitting, setIsSubmitting] = React.useState({})
  const [removing, setRemoving] = React.useState(false)
  const channelsApi = configurations.channels

  React.useEffect(() => {
    getAllWebWidget()
  }, [])

  React.useEffect(() => {
    if (widgetIdToEdit) getByIdWebWidget(widgetIdToEdit)
  }, [widgetIdToEdit])

  React.useEffect(() => {
    if (!dataToEdit) setWidgetIdToEdit('')
  }, [dataToEdit])

  const toggleRemoveModal = (widgetId) => {
    setIsOpenRemoveModal(!isOpenRemoveModal)
    if (widgetId) {
      setWidgetIdToRemove(widgetId)
    } else {
      setWidgetIdToRemove('')
    }
  }

  const onCopyWidgetToQR = async (widgetId) => {
    try {
      const { data } = await channelsApi.getByIdWebWidget(widgetId)
      if (!data) return
      onDataWidgetToQR(data)
    } catch (error) {
      console.error(error)
    }
  }

  const getAllWebWidget = async () => {
    try {
      setLoading(true)
      const { data } = await channelsApi.getAllWebWidget()
      if (data?.length) setWidgets(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getByIdWebWidget = async (id) => {
    try {
      const { data } = await channelsApi.getByIdWebWidget(id)
      if (data) setDataToEdit(data)
    } catch (error) {
      setDataToEdit(null)
      console.error(error)
    }
  }

  const getByIdWebWidgetToPreview = async (id, idx) => {
    try {
      setIsSubmitting({ ...isSubmitting, [idx]: true })
      const { data } = await channelsApi.getByIdWebWidget(id)
      if (data) {
        let widgets = data
        let _channels = []
        let _channelList = _.cloneDeep(channels)
        widgets.channels.forEach(it => {
          _channelList.forEach(it2 => {
            if (it2._id === it.identifier) {
              it2['isChecked'] = true
              it2['isMobile'] = it?.isMobile
              it2['isDesktop'] = it?.isDesktop
              _channels.push({ ...it2, })
            }
          })
        })
        widgets.channels = _channels

        setDataToPreview(widgets)
        setIsOpenModalWebWidgetDisplay(true)
      }
    } catch (error) {
      setDataToPreview(null)
      setIsOpenModalWebWidgetDisplay(false)
      console.error(error)
    } finally {
      setIsSubmitting({ ...isSubmitting, [idx]: false })
    }
  }

  const onDelete = async () => {
    try {
      setRemoving(true)
      await channelsApi.removeWebWidget(widgetIdToRemove)
      getAllWebWidget()
      getAllWebWidgetExternal()
      toastMessage(lang('channels_message_success_widget'))
    } catch (error) {
      toastMessage(lang('channels_message_error_generic'), 'error')
      console.error(error)
    } finally {
      setRemoving(false)
      setIsOpenRemoveModal(false)
      setWidgetIdToRemove('')
    }
  }

  return (
    <div className='web-widget-edit'>
      {widgetIdToEdit ? (
        <WebWidgetCreator
          key='WebWidgetCreatorEdit'
          dataToEdit={dataToEdit}
          channels={channels}
          createWebWidget={createWebWidget}
          setDataToEdit={setDataToEdit}
          getAllWebWidgetExternal={getAllWebWidgetExternal}
        />
      ) : (
        <>
          <h1>{lang('channels_web_widget_edit')}</h1>
          <legend>{lang('channels_web_widget_modal_subtitle_edit')}</legend>
          <div className='widgets-list-wrapper'>
            {widgets.length ? widgets.map((it, idx) => {
              return (
                <div key={`key-${idx}`} className='widgets-list'>
                  <div className='name-wrapper'>
                    {it.name || it.token}
                  </div>
                  <div className='buttons-wrapper'>
                    <div className='buttons-tags'>
                      <ButtonTag className='button-tag-copy' value={_.get(valueButtonCopy, [idx]) || lang('channels_buttons_code')} onClick={() => {
                        setValueButtonCopy({ ...valueButtonCopy, [idx]: lang('channels_buttons_code_copied') })
                        const code = `<script src="${DNS_URLS.aocsScript}" async data-aocsToken="${it.token}"></script>`
                        navigator.clipboard.writeText(code)
                        setTimeout(() => {
                          setValueButtonCopy({ ...valueButtonCopy, [idx]: null })
                        }, 2000)
                      }} />
                      <ButtonTag className='button-tag-preview' value={lang('dashboard_preview')} onClick={() => getByIdWebWidgetToPreview(it._id, idx)} isSubmitting={_.get(isSubmitting, [idx]) || false} />
                    </div>
                    <div className='buttons-icons'>
                      <div title={lang('tooltip_sms_clone_widget_to_qr_poster')}>
                        <img
                          src={getStaticImage('/icons/orange-brand/clonar.svg')}
                          alt={lang('tooltip_sms_clone_widget_to_qr_poster')}
                          onClick={() => onCopyWidgetToQR(it._id)}
                        />
                      </div>
                      <div>
                        <img
                          src={getStaticImage('/icons/orange-brand/icon-edit.svg')}
                          alt={lang('tooltip_sms_edit_widget')}
                          onClick={() => setWidgetIdToEdit(it._id)}
                        />
                      </div>
                      <div>
                        <img
                          src={getStaticImage('/icons/orange-brand/icon-delete.svg')}
                          alt={lang('tooltip_sms_delete_widget')}
                          onClick={() => toggleRemoveModal(it._id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            }) : (
              <span className='no-widget-list'>
                {lang(loading ? 'channels_widgets_loading' : 'channels_widgets_not_created')}
              </span>
            )}
          </div>
        </>
      )}
      {dataToPreview ? (
        <WebWidgetDisplay
          isOpen={isOpenModalWebWidgetDisplay}
          toggle={() => {
            setIsOpenModalWebWidgetDisplay(!isOpenModalWebWidgetDisplay)
            setDataToPreview(null)
          }}
          selectedChannels={dataToPreview?.channels}
          primaryColor={dataToPreview?.primaryColor}
          webWidgetToken={dataToPreview?.token}
          widget={dataToPreview}
          isNew
        />
      ) : null}
      <ModalDelete
        isOpen={isOpenRemoveModal}
        toggle={toggleRemoveModal}
        header={lang('channels_remove_widget')}
        text1={lang('dashboard_sure-want-delete-channel')}
        text2={lang('channels_remove_widget_legend')}
        event={onDelete}
        isSubmitting={removing}
      />
    </div>
  )
}

export default WebWidgetEdit
